/**
* Data model that represents a Queue offered at a Location
*
* @class QueueModel
*/
var QueueModel = function ( data ) {
	var self;	// Convenience reference so the context of 'this' becomes clearer

	// Predicate this data model on the AbstractDataModel.
	// This establishes core functionality required of DataModels,
	// which can be overwritten by methods below.
	// Specifically, conversion of XML data to JSON
	AbstractDataModel.apply( this, arguments );

	self = this;

	// Observable variables represented by this data model
	self.appointmentsEnabled	= null;
	self.description			= null;
	self.id						= null;
	self.locationId				= null;
	self.name					= null;
	self.privatePhoneDigitCount	= null;

	self.appointmentTransactionTypesWS = new AppointmentTransactionTypesWS(window.qcal);


	self.transactionTypes = ko.computed( function () {
		return self.appointmentTransactionTypesWS.transactionTypes();
	});

	self.indexedTransactionTypes = ko.pureComputed(function () {
		return self.transactionTypes().reduce(function (index, value)	{
			index[value.id] = value
			return index;
		}, {})
	})

	/**
	* Method to convert the XML data representing this DataModel
	* into observed variables above.
	*
	* @method loadData
	* @param {XMLString} data XML String representing this model's data
	* @return {QueueModel} Returns the data model as chainable, for best practice
	*/
	self.loadData = function ( data ) {
		var i = 0,
			tJSON = null,
			tts = [];

		// Call the superclass method of the same name
		// This loads the XML into the object's data member
		// and converts the data into JSON for easy assignment
		AbstractDataModel.prototype.loadData.call( self, data );

		self.appointmentsEnabled	= self.parseBoolean( self.json.appointmentsEnabled );
		self.description			= self.json.description;
		self.id						= parseInt( self.json.id, 0 );
		self.locationId				= parseInt( self.json.locationId, 0 );
		self.name					= self.json.name;
		self.minPartySize 			= parseInt(self.json.minPartySize, 10);
		self.maxPartySize 			= parseInt(self.json.maxPartySize, 10);

		if ( self.json.privatePhoneDigitCount != null ) {
			self.privatePhoneDigitCount	= parseInt( self.json.privatePhoneDigitCount, 0 );
		}

		// 2016-01-06
		// EVEN THOUGH this data has transaction types, they do not contain the data needed
		// to differentiate which transaction types are appointment transaction types and, indeed,
		// which of the transaction types that appear to be appointment transaction types
		// are actually attributed to this queue. So frustrating.
		// INSTEAD, a subsequent call needs to be initiated to determine that information.
		// Hopefully, the return data of the call which generated this data can at some point
		// in the future be refactored to include a flag to make better use of available data
		// instead of putting additional load on the server.
		self.appointmentTransactionTypesWS.queueId( self.id );
		self.appointmentTransactionTypesWS.doRequest();

		// Return self (QueueModel) to be chainable, for best practice
		return self;
	};


	// If the model was initialized with a data parameter,
	// call the loadData method to populate the observed variables.
	if ( data ) {
		self.loadData( data );
	}

	// Return self (loadData) to be chainable, for best practice
	return self;
};

QueueModel.prototype = AbstractDataModel.prototype;
QueueModel.prototype.constructor = QueueModel;
